import { defineStore } from 'pinia'

export const usePlansStore = defineStore('plans', {
  state: () => ({

    pricing: {
      "12": { "USD": "9.95", "EUR": "9.95", "GBP": "8.95", "CAD": "13.95", "AUD": "14.95", "INR": "730.00", "JPY": "1237.00" },
      "13": { "USD": "99.50", "EUR": "99.50", "GBP": "89.50", "CAD": "139.50", "AUD": "149.50", "INR": "7300.00", "JPY": "12370.00" },
      "20": { "USD": "19.95", "EUR": "19.95", "GBP": "17.95", "CAD": "24.95", "AUD": "29.95", "INR": "1463.00", "JPY": "2474.00" },
      "21": { "USD": "199.50", "EUR": "199.50", "GBP": "179.50", "CAD": "249.50", "AUD": "299.50", "INR": "14630.00", "JPY": "24740.00" },
      "23": { "USD": "69.50", "EUR": "69.50", "GBP": "64.50", "CAD": "89.50", "AUD": "99.50", "INR": "5150.00", "JPY": "8930.00" },
      "24": { "USD": "6.95", "EUR": "6.95", "GBP": "6.45", "CAD": "8.95", "AUD": "9.95", "INR": "515.00", "JPY": "893.00" },
      "400": { "USD": "3.95", "EUR": "3.95", "GBP": "3.45", "CAD": "5.95", "AUD": "6.45", "INR": "299.00", "JPY": "580.00" },
      "401": { "USD": "39.50", "EUR": "39.50", "GBP": "34.50", "CAD": "59.50", "AUD": "64.50", "INR": "2990.00", "JPY": "5800.00" },
      "406": { "USD": "34.95", "EUR": "34.95", "GBP": "29.95", "CAD": "49.95", "AUD": "56.95", "INR": "2599.00", "JPY": "4980.00" },
      "407": { "USD": "349.50", "EUR": "349.50", "GBP": "299.50", "CAD": "499.50", "AUD": "569.50", "INR": "25990.00", "JPY": "49800.00" },
      "408": { "USD": "49.95", "EUR": "49.95", "GBP": "41.95", "CAD": "71.95", "AUD": "79.95", "INR": "3699.00", "JPY": "7200.00" },
      "409": { "USD": "499.50", "EUR": "499.50", "GBP": "419.50", "CAD": "719.50", "AUD": "799.50", "INR": "36990.00", "JPY": "72000.00" },
      "410": { "USD": "79.95", "EUR": "79.95", "GBP": "67.95", "CAD": "114.95", "AUD": "129.95", "INR": "5999.00", "JPY": "11400.00" },
      "411": { "USD": "799.50", "EUR": "799.50", "GBP": "679.50", "CAD": "1149.50", "AUD": "1299.50", "INR": "59990.00", "JPY": "114000.00" },
      "412": { "USD": "139.95", "EUR": "139.95", "GBP": "119.95", "CAD": "199.95", "AUD": "229.95", "INR": "9999.00", "JPY": "19900.00" },
      "413": { "USD": "1399.50", "EUR": "1399.50", "GBP": "1199.50", "CAD": "1999.50", "AUD": "2299.50", "INR": "99990.00", "JPY": "199000.00" }
    },


// Base feature template - all features start as false
    baseFeatures: {
      freeStorage: false,
      storage: false,
      hd: false,
      fhd: false,
      '4k': false,
      addOns: false,
      rss: false,
      rssAuto: false,
      storageExt: false,
      linksAtTime: false,
      antivirus: false,
      seedrUltra: false,
      ftp: false,
      webdav: false,
      ratio1to1: false,
      ratio2to1: false,
      ratio5to1: false,
      hdStreaming: false,
      parallelDownloads: false,
      privateTrackers: false
    },

    // Plan-specific feature overrides (only what's different from base)
    planFeatures: {
      lite: {
        freeStorage: '5GB',
        storage: '10GB',
        addOns: true,
        rss: true,
        storageExt: '1GB',
        linksAtTime: '2'
      },
      basic: {
        freeStorage: 'ok',
        storage: '30GB',
        addOns: true,
        rss: true,
        rssAuto: true,
        storageExt: '2GB',
        linksAtTime: '2',
        antivirus: true,
        seedrUltra: true,
        ratio1to1: true,
        hdStreaming: true
      },
      pro: {
        freeStorage: 'ok',
        storage: '100GB',
        hd: true,
        addOns: true,
        rss: true,
        rssAuto: true,
        storageExt: '5GB',
        linksAtTime: '5',
        antivirus: true,
        seedrUltra: true,
        ftp: true,
        ratio1to1: true,
        ratio2to1: true,
        hdStreaming: true
      },
      master: {
        freeStorage: 'ok',
        storage: '1TB',
        hd: true,
        fhd: true,
        '4k': true,
        addOns: true,
        rss: true,
        rssAuto: true,
        storageExt: '10GB',
        linksAtTime: '25',
        antivirus: true,
        seedrUltra: true,
        ftp: true,
        webdav: true,
        ratio1to1: true,
        ratio2to1: true,
        ratio5to1: true,
        hdStreaming: true,
        parallelDownloads: true,
        privateTrackers: true
      },
      // Gold plans inherit from master + their specific storage/limits
      gold1: {
        storage: '2TB',
        storageExt: '20GB',
        linksAtTime: '35'
      },
      gold2: {
        storage: '3TB',
        storageExt: '30GB',
        linksAtTime: '50'
      },
      gold3: {
        storage: '5TB',
        storageExt: '50GB',
        linksAtTime: '70'
      },
      gold4: {
        storage: '10TB',
        storageExt: '100GB',
        linksAtTime: '100'
      }
    },

    // Plan basic info (no duplication here)
    planInfo: {
      lite: {
        key: 'lite',
        name: 'Lite',
        icon: '/images/plan_lite_logo_SVG.svg',
        topBadge: 'Available Now',
        storage: '10GB',
        taskSlots: 2,
        uploadSlots: null,
        billingPlanIds: { monthly: '400', yearly: '401' }, // Added yearly: '401'
        pricing: { monthly: '3.95', yearly: '39.50', savings: '7.90' }, // Added yearly and savings
        ctaText: 'Go Lite',
        displayFeatures: ['Fast Downloads', 'Uploads', 'Storage Cleanup', 'Tasks Slots', 'Search everywhere', 'Sync your cloud sources']
      },
      basic: {
        key: 'basic',
        name: 'Basic',
        icon: '/images/plan_basic_logo_SVG.svg',
        topBadge: null,
        storage: '30GB',
        taskSlots: 2,
        uploadSlots: null,
        billingPlanIds: { monthly: '24', yearly: '23' },
        pricing: { monthly: '6', yearly: '69', savings: '13.90' },
        ctaText: 'Select Plan',
        displayFeatures: { type: 'standard' }
      },
      pro: {
        key: 'pro',
        name: 'Pro',
        icon: '/images/plan_pro_logo_SVG.svg',
        topBadge: 'Popular',
        storage: '100GB',
        taskSlots: 4,
        uploadSlots: null,
        billingPlanIds: { monthly: '12', yearly: '13' },
        pricing: { monthly: '9', yearly: '99', savings: '19.90' },
        ctaText: 'Select Plan',
        displayFeatures: { type: 'standard' }
      },
      master: {
        key: 'master',
        name: 'Master',
        icon: '/images/plan_master_logo_SVG.svg',
        topBadge: null,
        storage: '1TB',
        taskSlots: 10,
        uploadSlots: null,
        billingPlanIds: { monthly: '20', yearly: '21' },
        pricing: { monthly: '19', yearly: '199', savings: '39.90' },
        ctaText: 'Select Plan',
        displayFeatures: { type: 'standard' }
      },
      gold1: {
        key: 'gold1',
        name: 'GOLD One',
        icon: '/images/plan_gold_logo_SVG.svg',
        topBadge: null,
        storage: '2TB',
        taskSlots: 35,
        uploadSlots: 50,
        billingPlanIds: { monthly: '406', yearly: '407' },
        pricing: { monthly: '34', yearly: '349', savings: '69.90' },
        ctaText: 'Upgrade Now',
        limitedCapacity: false,
        displayFeatures: { type: 'gold', goldFeatures: ['Uncapped speeds', 'Premium queue priority', 'FTP/SFTP Access'] }
      },
      gold2: {
        key: 'gold2',
        name: 'GOLD Two',
        icon: '/images/plan_gold_logo_SVG.svg',
        topBadge: 'Recommended',
        storage: '3TB',
        taskSlots: 50,
        uploadSlots: 70,
        billingPlanIds: { monthly: '408', yearly: '409' },
        pricing: { monthly: '49', yearly: '499', savings: '99.90' },
        ctaText: 'Upgrade Now',
        limitedCapacity: false,
        displayFeatures: { type: 'gold', goldFeatures: ['Uncapped speeds', 'Premium queue priority', 'FTP/SFTP Access'] }
      },
      gold3: {
        key: 'gold3',
        name: 'GOLD Three',
        icon: '/images/plan_gold_logo_SVG.svg',
        topBadge: null,
        storage: '5TB',
        taskSlots: 70,
        uploadSlots: 100,
        billingPlanIds: { monthly: '410', yearly: '411' },
        pricing: { monthly: '79', yearly: '799', savings: '169.90' },
        ctaText: 'Upgrade Now',
        limitedCapacity: true,
        displayFeatures: { type: 'gold', goldFeatures: ['Uncapped speeds', 'Premium queue priority', 'FTP/SFTP Access'] }
      },
      gold4: {
        key: 'gold4',
        name: 'GOLD Four',
        icon: '/images/plan_gold_logo_SVG.svg',
        topBadge: null,
        storage: '10TB',
        taskSlots: 100,
        uploadSlots: 130,
        billingPlanIds: { monthly: '412', yearly: '413' },
        pricing: { monthly: '139', yearly: '1399', savings: '259.90' },
        ctaText: 'Upgrade Now',
        limitedCapacity: true,
        displayFeatures: { type: 'gold', goldFeatures: ['Uncapped speeds', 'Premium queue priority', 'FTP/SFTP Access'] }
      }
    },

    // Feature names for translation
    featureNames: {
      freeStorage: 'plans-container.features.free-storage-title',
      storage: 'plans-container.features.storage-title',
      hd: 'plans-container.features.hd-title',
      fhd: 'plans-container.features.fhd-title',
      '4k': 'plans-container.features.4k-title',
      addOns: 'plans-container.features.add-on-title',
      rss: 'plans-container.features.rss-title',
      rssAuto: 'plans-container.features.rss-auto-title',
      storageExt: 'plans-container.features.storage-ext-title',
      linksAtTime: 'plans-container.features.links-title',
      antivirus: 'plans-container.features.antivirus-title',
      seedrUltra: 'plans-container.features.seedr-ultra-title',
      ftp: 'plans-container.features.ftp-title',
      webdav: 'plans-container.features.webdav-title',
      ratio1to1: 'plans-container.features.1-1-title',
      ratio2to1: 'plans-container.features.2-1-title',
      ratio5to1: 'plans-container.features.5-1-title',
      hdStreaming: 'plans-container.features.streaming-title',
      parallelDownloads: 'plans-container.features.8-down-title',
      privateTrackers: 'plans-container.features.trackers-title'
    },

    // Current user settings
    currentCurrency: 'USD',
    selectedPlan: 'pro',
    userPlan: 'start',
    yearlyBillingSelected: false,


  }),

  // getters and actions are untested and where done by ai. Seams some of them could be useful.

  getters: {
    // Build complete features for a plan (base + overrides + inheritance)
    getPlanFeatures: (state) => (planKey) => {
      let features = { ...state.baseFeatures }

      // Apply master features to all gold plans first
      if (planKey.startsWith('gold')) {
        Object.assign(features, state.planFeatures.master)
      }

      // Apply plan-specific overrides
      if (state.planFeatures[planKey]) {
        Object.assign(features, state.planFeatures[planKey])
      }

      // Convert to SPlanFeatures format
      return Object.entries(features).map(([key, value]) => ({
        key,
        name: state.featureNames[key],
        planDetail: value === true ? 'ok' : value === false ? '-' : value
      }))
    },

    // Get plan info (no duplication)
    getPlan: (state) => (planKey) => {
      return state.planInfo[planKey] || null
    },

    // Get all plans as array
    getAllPlans: (state) => {
      return Object.values(state.planInfo)
    },

    // Get price for display (uses local pricing first, falls back to server pricing)
    getPlanPrice: (state) => (planKey, billing = 'monthly') => {
      const plan = state.planInfo[planKey]
      if (!plan) return null

      // For Lite plan, always return the local price since it doesn't follow .95 pattern
      if (planKey === 'lite') {
        return plan.pricing.monthly
      }

      // For other plans, use local pricing for display consistency
      if (plan.pricing && plan.pricing[billing]) {
        return plan.pricing[billing]
      }

      // Fallback to server pricing
      const billingPlanId = plan.billingPlanIds[billing]
      if (!billingPlanId) return null

      const priceData = state.serverPricing[billingPlanId]
      if (!priceData) return null

      // Remove .00 or .95 suffix for clean display
      const price = priceData[state.currentCurrency]
      return price ? price.replace(/\.95$|\.00$/, '') : null
    },

    // Get savings amount (uses local data)
    getSavings: (state) => (planKey) => {
      const plan = state.planInfo[planKey]
      if (!plan || !plan.pricing || !plan.pricing.savings) return null

      return plan.pricing.savings
    },

    // Get payment URL for plan
    getPaymentUrl: (state) => (planKey, billing = 'monthly') => {
      const plan = state.planInfo[planKey]
      if (!plan) return null

      if (planKey === 'lite') {
        return 'https://www.seedr.cc/paythrough?billing_plan_id=400'
      }

      const billingPlanId = plan.billingPlanIds[billing]
      if (!billingPlanId) return null

      return `https://www.seedr.cc/premium?billing_plan_id=${billingPlanId}`
    },

    // Check if plan is gold plan
    isGoldPlan: (state) => (planKey) => {
      return planKey.startsWith('gold')
    },

    // Get standard plans (non-gold)
    getStandardPlans: (state) => {
      return Object.values(state.planInfo).filter(plan => !plan.key.startsWith('gold'))
    },

    // Get gold plans
    getGoldPlans: (state) => {
      return Object.values(state.planInfo).filter(plan => plan.key.startsWith('gold'))
    }
  },

  actions: {
    // Set current currency
    setCurrency(currency) {
      this.currentCurrency = currency
    },

    // Set selected plan
    setSelectedPlan(planKey) {
      this.selectedPlan = planKey
    },

    // Set user's current plan
    setUserPlan(planKey) {
      this.userPlan = planKey
    },

    // Load pricing data from server (if needed)
    async loadServerPricing() {
      try {
        // This would typically fetch from your API
        // const response = await fetch('/api/pricing')
        // const data = await response.json()
        // this.serverPricing = data
        console.log('Server pricing loaded')
      } catch (error) {
        console.error('Failed to load server pricing:', error)
      }
    }
  }
})
